// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1jRqQ","range":"MonthRangeSwitch_range__IcB5Z","disabled":"MonthRangeSwitch_disabled__1xkal"};